/* eslint-disable no-unused-vars */
// import logo from './logo.svg';
import './App.css';
import Header from './components/Header'
import { Routes, Route } from 'react-router-dom';
import Home from './components/Home'
import { BrowserRouter } from 'react-router-dom';
import {ThemeProvider} from '@mui/material/styles'
import {endpoint, theme} from './config'
import Layout from './components/Layout';
import { Provider, useDispatch } from 'react-redux';
import {store, updateVideos, updateGenres, updateContentRatings} from './reduxStore'
import { useEffect } from 'react';
import axios from 'axios';
import {useSelector} from 'react-redux'
import {useState} from 'react'
import VideoPage from './components/VideoPage';

function App() {
  const dispatch = useDispatch()

  // const videos = useSelector(state => state.videos)
  // const filters = useSelector(state => state.filters)
  
  // let [genres, setGenres] = useState([])
  // let [contentRatings, setContentRatings] = useState([])

  const loadData = async () => {
    const res = await axios.get(endpoint+'?sortBy=releaseDate')
    dispatch(updateVideos(res.data.videos))

    // setGenres(res.data.videos.map(video => video.genre).filter((genre, i, arr) => arr.indexOf(genre) === i))
    // setContentRatings(res.data.videos.map(video => video.contentRating).filter((contentRating, i, arr) => arr.indexOf(contentRating) === i))

    // res.data.videos.forEach(video => {
    //   genres.push(video.genre)
    //   contentRatings.push(video.contentRating)
    // })
    // genres = genres.filter((genre, i, arr) => arr.indexOf(genre) == i)
    // contentRatings = contentRatings.filter((genre, i, arr) => arr.indexOf(genre) == i)

  }
  
  useEffect(()=> {
    loadData()
    // console.log(videos, filters)
  }, [])
  
  // useEffect(() => {
    // dispatch(updateGenres(genres))
    // dispatch(updateContentRatings(contentRatings))
    // console.log(genres, contentRatings)
  // }, [genres, contentRatings])


  return (
    <div className="App">
      
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route path="/:id" element={<VideoPage/>} />
              <Route index element={<Home/>}/>
            </Route>
          </Routes>
        </ThemeProvider>
      </BrowserRouter>
      
    </div>
  );
}

export default App;
